import MessageLog from './routes/message_log/MessageLog.vue';
import MessageSettings from './routes/message_settings/MessageSettings.vue';

const MessageServiceRoutes = [
  {
    path: 'message-log',
    name: 'MessageLog',
    component: MessageLog,
  },
  {
    path: 'message-settings',
    name: 'MessageSettings',
    component: MessageSettings,
  },
];

export default MessageServiceRoutes;
